export const TASK_TYPE_COLUMNS = {
  ACTION: 'ACTION',
  SHORT_NAME: 'SHORT_NAME',
  DESCRIPTION: 'DESCRIPTION'
};

export const TASK_TYPE_KEYS = {
  ACTION: 'action',
  SHORT_NAME: 'short_name',
  DESCRIPTION: 'description'
};
